/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fork, takeLatest } from 'redux-saga/effects';
import ActionConstants from '../constants/';
import workerSaga from './workerSaga';
import { takeLatestUntilApiCancel } from './merchantListing';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* imeiWatcher(): Generator<any, void, unknown> {
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_IMEI_DETAILS);
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_IMEI_BULK_UPLOAD_HISTORY_LIST,
  );
  yield takeLatest(ActionConstants.POST_VALIDATE_IMEI, workerSaga);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_REF_FILE_IMEI_LIST);
}
